(function ($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfFieldDatepicker', ['thfFieldHelper', '$sce', function (thfFieldHelper, $sce) {
        var link = function (scope, el, attrs) {
            scope.isValid = thfFieldHelper.isValid;
            scope.labelIdentifier = thfFieldHelper.formLabelIdentifier();
            scope.tooltip = $sce.trustAsHtml((typeof scope.field.tooltip !== 'undefined') ? scope.field.tooltip : '');

            scope.datePickerOptions = {
                changeYear: true,
                changeMonth: true,
                dayNamesMin: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
                dateFormat: 'dd/mm/yy',
                showOn: "button",
                buttonImage: "/static/img/common/backgrounds/trans.gif",
                buttonText: "Select date",
                buttonImageOnly: true
            };

            function updateOptions() {
                if (typeof scope.field.datePickerOptions !== 'undefined') {
                    scope.datePickerOptions = $.extend({}, scope.datePickerOptions, scope.field.datePickerOptions);
                }
            }
            updateOptions();

            scope.$watch('field.datePickerOptions', updateOptions, true );

        };
        return {
            'restrict': 'E',
            'replace': true,
            'scope': {
                'formState': '=',
                'formField': '=',
                'formModel': '=',
                'field': '=',
                'validation': '=',
                'model': '=',
                'ngModel': '=',
                'fieldActions': '=',
                'validationRules': '='
            },
            'link': link,
            'templateUrl': function() {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/fields/datepicker.html');
            }
        };
    }]);
})(jQuery, angular, window);
